
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input } from '@angular/core';
import { CommonService } from '../../service/shared.service';
import { ProcessDetail, ProcessDetailActionRequest } from '../../models/process.model';

@Component({
    selector: 'process-detail',
    templateUrl: './process-detail.component.html',
    styleUrls: ['./process-detail.component.css']
})
export class ProcessDetailComponent extends SiriusBaseComponent<any> {    
    @Input('ProcessRef') processRef: string;
    @Input('ProcessStatus') processStatus: string;
    @Input('IsLive') isLive: boolean;
    processDetail: ProcessDetail = null;
    noResult: boolean = false;
    TelephoneNo: string = "";
    ReceiverTelephoneNo: string = "";
    Iban: string = "";
    ReceiverIban: string = "";
    processAmount: string = "";
    isProcessDetailOpen: boolean = true;
    isSellerDetailOpen: boolean = false;
    isBuyerDetailOpen: boolean = false;
    /* String Resource */
    processDetail_ProcessDetail: string;
    processDetail_FirmReference: string;
    processDetail_ProcessStatus: string;
    processDetail_ProductNo: string;
    processDetail_ProcessAmount: string;
    processDetail_SellerDetail: string;
    processDetail_IdentityNo: string;
    processDetail_Name: string;
    processDetail_Surname: string;
    processDetail_TelephoneNo: string;
    processDetail_Email: string;
    processDetail_Iban: string;
    processDetail_ReceiverDetail: string;
    processDetail_ReceiverIdentityNo: string;
    processDetail_ReceiverName: string;
    processDetail_ReceiverSurname: string;
    processDetail_ReceiverTelephoneNo: string;
    processDetail_ReceiverEmail: string;
    processDetail_ReceiverIban: string;
    constructor(private commonService: CommonService) {
        super();
    }
    OnInit() {
        this.setStringResource();
        if (this.commonService.selectedProcessDetail != null) {
            if (this.commonService.selectedProcessDetail.processRef == this.processRef) {
                this.processDetail = this.commonService.selectedProcessDetail.data as ProcessDetail;
                this.transformProcessDetail();
            }
            else {
                this.commonService.selectedProcessDetail = null;
                this.callProcessDetailService();
            }
        }
        else {
            this.callProcessDetailService();
        }     
    }
    setStringResource() {
        this.processDetail_ProcessDetail = this.resourceService.getResource("processDetail_ProcessDetail");
        this.processDetail_FirmReference = this.resourceService.getResource("processDetail_FirmReference");
        this.processDetail_ProcessStatus = this.resourceService.getResource("processDetail_ProcessStatus");
        this.processDetail_ProductNo = this.resourceService.getResource("processDetail_ProductNo");
        this.processDetail_ProcessAmount = this.resourceService.getResource("processDetail_ProcessAmount");
        this.processDetail_SellerDetail = this.resourceService.getResource("processDetail_SellerDetail");
        this.processDetail_IdentityNo = this.resourceService.getResource("processDetail_IdentityNo");
        this.processDetail_Name = this.resourceService.getResource("processDetail_Name");
        this.processDetail_Surname = this.resourceService.getResource("processDetail_Surname");
        this.processDetail_TelephoneNo = this.resourceService.getResource("processDetail_TelephoneNo");
        this.processDetail_Email = this.resourceService.getResource("processDetail_Email");
        this.processDetail_Iban = this.resourceService.getResource("processDetail_Iban");
        this.processDetail_ReceiverDetail = this.resourceService.getResource("processDetail_ReceiverDetail");
        this.processDetail_ReceiverIdentityNo = this.resourceService.getResource("processDetail_ReceiverIdentityNo");
        this.processDetail_ReceiverName = this.resourceService.getResource("processDetail_ReceiverName");
        this.processDetail_ReceiverSurname = this.resourceService.getResource("processDetail_ReceiverSurname");
        this.processDetail_ReceiverTelephoneNo = this.resourceService.getResource("processDetail_ReceiverTelephoneNo");
        this.processDetail_ReceiverEmail = this.resourceService.getResource("processDetail_ReceiverEmail");
        this.processDetail_ReceiverIban = this.resourceService.getResource("processDetail_ReceiverIban");
    }
    callProcessDetailService() {
        var processDetailActionRequest: ProcessDetailActionRequest = {
            ProcessRef: this.processRef,
            IsLive: this.isLive
        }
        var promise = this.commonService.GetProcessDetail(this.dataService, processDetailActionRequest);
        promise.then((result) => {
            if (result != null) {
                this.processDetail = result as ProcessDetail;
                if (!this.processDetail.IsThereError) {                 
                    this.transformProcessDetail();
                    this.commonService.selectedProcessDetail = { processRef: this.processRef, data: this.processDetail };  
                    this.noResult = false;
                }
                else {
                    this.processDetail = null;
                    this.noResult = true;
                }             
            }
        });
    }
    transformProcessDetail() {
        this.TelephoneNo = this.GetTelephoneText(this.processDetail.TelephoneNo);
        this.ReceiverTelephoneNo = this.GetTelephoneText(this.processDetail.ReceiverTelephoneNo);
        this.Iban = this.GetIbanText(this.processDetail.Iban);
        this.ReceiverIban = this.GetIbanText(this.processDetail.ReceiverIban);
        this.processAmount = this.GetAmountText(this.processDetail.TotalAmount);
    }  
    processDetailClicked() {
        this.isProcessDetailOpen = !this.isProcessDetailOpen;
    }
    sellerDetailClicked() {
        this.isSellerDetailOpen = !this.isSellerDetailOpen;
    }

    buyerDetailClicked() {
        this.isBuyerDetailOpen = !this.isBuyerDetailOpen;
    }
    GetTelephoneText(phone: string) {
        if (phone != null && phone.trim().length == 11) {
            return phone.substr(0, 4) + " " + phone.substr(4, 3) + " " + phone.substr(7, 2) + " " + phone.substr(9, 2);
        }
        return phone;
    }
    GetIbanText(iban: string) {
        if (iban != null && iban.length > 0) {
            let ibanList = iban.match(/.{1,4}/g);
            return ibanList.join(' ');
        }
        return "";
    }
    GetAmountText(amountObject) {
        if (amountObject.Value != null && amountObject.Currency != null) {
            return amountObject.Value.toLocaleString("tr-TR") + " " + amountObject.Currency.Name;
        }
        return amountObject.Value;
    }
}
